import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const AuxiliaryHydraulicsPerformance = ({
  auxiliaryHydraulicsPerformance,
}: SpecProps<"auxiliary_hydraulics_performance">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!auxiliaryHydraulicsPerformance) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.auxiliaryHydraulicsPerformance",
    message: "Hydraulics performance",
    comment: "Label for 'Auxiliary hydraulics performance'",
  });

  const value = i18n.t({
    id: "itemPageLayout.keyInfo.hydraulics_performance.postfix",
    message: "{performance} L/min",
    comment: "Auxiliary hydraulics performance for liters pr minute postfix in ad specification",
    values: {
      performance: formatNumber(auxiliaryHydraulicsPerformance, locale),
    },
  });

  return <FieldValuePair field={field} value={value} />;
};
